import { render, staticRenderFns } from "./SelectMenu.vue?vue&type=template&id=a2a7aedc&scoped=true&"
import script from "./SelectMenu.vue?vue&type=script&lang=js&"
export * from "./SelectMenu.vue?vue&type=script&lang=js&"
import style0 from "./SelectMenu.vue?vue&type=style&index=0&id=a2a7aedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a7aedc",
  null
  
)

export default component.exports